export default __webpack_public_path__ + "locales/ko-KR/JavascriptSdk.json?hash=44bab760265a39eba3c15d9f76833a5c";